import { Fragment, useEffect, useState } from "react";
import "./subject_component.scss";

///////////////////Desktop
import HeaderComponent from "../../structure_components/desktop_screens/header_component/header_component";

///////Mobile////////////////////
import MobileLeftSideBarComponent from "../../structure_components/mobile_screens/mobile_left_sideBar_component/mobile_left_sideBar_component";
import MobileHeaderComponent from "../../structure_components/mobile_screens/mobile_header_component/mobile_header_component";
import MobileRightSideBarComponent from "../../structure_components/mobile_screens/mobile_right_sideBar_component/mobile__right_sideBar_component";

import SubjectContentComponent from "../subject_component/subject_content_component/subject_content_component";
import LoaderPopUp from "../../../../components/loader/loader";
import { connect } from "react-redux";

const SubjectComponent = (props) => {
  let { history, loader, userData, userPreference } = props;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const setWidth = () => {
    setWindowWidth(window.innerWidth)
  }
  useEffect(() => {
    window.addEventListener( 'resize',setWidth)

    return (() => {
      window.removeEventListener('resize',setWidth)
    })
  },[windowWidth])

  return (
    <Fragment>
      <div className="subject_component_wrapper">
        <div className="subject_component_inner_wrapper">
          {windowWidth <= 480 ? (
            /////for Mobile Screens////////////////////
            <Fragment>
              <MobileLeftSideBarComponent />
              <MobileHeaderComponent
                userPreference={userPreference}
                userData={userData}
              />
              <MobileRightSideBarComponent history={history} />
              <SubjectContentComponent
                history={history}
                userPreference={userPreference}
              />
            </Fragment>
          ) : (
            /////for Screens greater than Mobile Screens////////////////////
            <Fragment>
              <div className="subject_component_right_wrapper">
                <HeaderComponent history={history} />
                <SubjectContentComponent
                  history={history}
                  userPreference={userPreference}
                />
              </div>
            </Fragment>
          )}
        </div>
      </div>
      {loader && <LoaderPopUp />}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    userData: state.auth.user,
    userPreference: state.userPreference,
  };
};

export default connect(mapStateToProps)(SubjectComponent);
